import { PiniaVuePlugin } from 'pinia'
// eslint-disable-next-line import/no-extraneous-dependencies
import { createLocalVue, mount } from '@vue/test-utils'
// eslint-disable-next-line import/no-extraneous-dependencies
import { createTestingPinia } from '@pinia/testing'
import { getComponentConfig } from 'www/test/functions'
import { useAppointmentDataStore, useDoctorDataStore } from 'www/vue_components/common/AppointmentPage/stores'
import { type DoctorWorkplace, getInitAdditionalData } from 'www/vue_components/common/AppointmentPage/interfaces'
import { APPOINTMENT_PLACE_TYPES } from 'www/vue_components/common/AppointmentPage/constants'
import DoctorSpecialities from 'src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/components/DoctorSpecialities.vue'

const getWorkplace = (specId: number, isInClub = false): DoctorWorkplace => ({
  id: specId,
  isInClub,
  clubDiscount: 30,
  speciality: {
    id: specId,
    name: specId.toString(),
  },
  priceList: {
    price: null,
    priceHome: null,
    priceOnline: null,
    priceMedtochkaTelemed: null,
    priceClub: null,
    priceClubLpu: null,
    priceClubCoupon: null,
  },
  age: {
    min: null,
    max: null,
  },
  isShowPhoneOnly: false,
  appointmentRestrictions: [],
})

const localVue = createLocalVue()
const localPinia = createTestingPinia({
  stubActions: false,
})

localVue.use(PiniaVuePlugin)

const appointmentDataStore = useAppointmentDataStore()
const doctorDataStore = useDoctorDataStore()
const spyOnUpdateStateSelectedDoctorSpecialityId = jest.spyOn(doctorDataStore, 'updateStateSelectedDoctorSpecialityId')

const getWrapper = (overrides = {}) => mount(DoctorSpecialities, getComponentConfig({
  localVue,
  pinia: localPinia,
  ...overrides,
}))

let wrapper:any

describe('DoctorSpecialities', () => {
  describe('Когда создаётся компонент', () => {
    beforeAll(() => {
      doctorDataStore.selectedDoctorSpecialityId = null
      doctorDataStore.doctorData.workplaces = [
        getWorkplace(1),
      ]
      wrapper = getWrapper()
    })
    test('Тогда выбирается специальность врача', () => {
      expect(spyOnUpdateStateSelectedDoctorSpecialityId).toHaveBeenCalled()
      expect(wrapper.vm.selectedDoctorSpecialityId).not.toBeNull()
    })
  })
  describe('Когда выбирается специальность', () => {
    beforeAll(() => {
      wrapper = getWrapper()
    })
    test('Тогда выбирается предвыбранная специальность', () => {
      appointmentDataStore.appointmentPlaceTypes.isClub = true
      appointmentDataStore.initAdditionalData = {
        ...getInitAdditionalData(),
        // @ts-ignore
        specialityId: 10,
      }
      doctorDataStore.doctorData.workplaces = [
        getWorkplace(1, true),
        getWorkplace(2),
        getWorkplace(10),
      ]

      expect(wrapper.vm.getClubOrDefaultWorkplaceId()).toBe(10)
    })
    test('Тогда выбирается первая клубная специальность', () => {
      appointmentDataStore.initAdditionalData = {
        ...getInitAdditionalData(),
        placeType: APPOINTMENT_PLACE_TYPES.club,
      }
      doctorDataStore.doctorData.workplaces = [
        getWorkplace(1),
        getWorkplace(2, true),
        getWorkplace(3, true),
        getWorkplace(4),
      ]

      expect(wrapper.vm.getClubOrDefaultWorkplaceId()).toBe(2)
    })
    test('Тогда выбирается первая специальность из списка специальностей', () => {
      appointmentDataStore.initAdditionalData = getInitAdditionalData()
      doctorDataStore.doctorData.workplaces = [
        getWorkplace(1),
        getWorkplace(2, true),
        getWorkplace(3, true),
        getWorkplace(4),
      ]

      expect(wrapper.vm.getClubOrDefaultWorkplaceId()).toBe(1)
    })
  })
})
